import React from "react";

const recommendations = [
  {
    id: 1,
    city: "Vancouver",
    route: "MIA - YVR",
    price: "$447*",
    typicalLow: "$1,030",
    typicalHigh: "$1,378",
    priceLevel: "low",
    tripType: "Round Trip",
    imageUrl:
      "https://images.unsplash.com/photo-1559511260-66a654ae982a?auto=format&fit=crop&w=600&q=80",
  },
  {
    id: 2,
    city: "San Francisco",
    route: "MIA - SFO",
    price: "$370*",
    typicalLow: "$900",
    typicalHigh: "$998",
    priceLevel: "low",
    tripType: "Round Trip",
    imageUrl:
      "https://images.unsplash.com/photo-1501594907352-04cda38ebc29?auto=format&fit=crop&w=600&q=80",
  },
  {
    id: 3,
    city: "Toronto",
    route: "MIA - YTO",
    price: "$317*",
    typicalLow: "$1,073",
    typicalHigh: "$1,338",
    priceLevel: "low",
    tripType: "Round Trip",
    imageUrl:
      "https://images.unsplash.com/photo-1517090504586-fde19ea6066f?auto=format&fit=crop&w=600&q=80",
  },
  {
    id: 4,
    city: "Seattle",
    route: "MIA - SEA",
    price: "$1,058*",
    typicalLow: "$1,063",
    typicalHigh: "$1,206",
    priceLevel: "low",
    tripType: "Round Trip",
    imageUrl:
      "https://images.unsplash.com/photo-1502175353174-a7a70e73b362?auto=format&fit=crop&w=600&q=80",
  },
];

const PriceIndicator = ({ level }) => {
  const arrowPosition =
    {
      low: "translate-x-[-12px]",
      medium: "translate-x-[0px]",
      high: "translate-x-[12px]",
    }[level] || "translate-x-[-12px]";

  return (
    <div className="flex shrink-0 flex-col items-center gap-1">
      <svg
        className={`h-2.5 w-2.5 text-slate-950 transition-transform duration-300 ${arrowPosition}`}
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path d="M12 21l-9-12h18l-9 12z" />
      </svg>
      <div className="flex gap-1">
        <div className="h-1.5 w-2.5 rounded-sm bg-emerald-500" />
        <div className="h-1.5 w-2.5 rounded-sm bg-amber-400" />
        <div className="h-1.5 w-2.5 rounded-sm bg-rose-500" />
      </div>
    </div>
  );
};

const RecommendedTrips = () => {
  return (
    <section className="w-full bg-white px-4 pb-14 font-sans sm:px-6 sm:py-16">
      <div className="mx-auto max-w-7xl">
        <div className="mb-8 flex flex-col gap-2 sm:mb-10 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="mb-2 text-xs font-black uppercase tracking-[0.18em] text-[#2871d3]">
              Explore deals
            </p>
            <h2 className="text-2xl font-black tracking-tight text-slate-950 sm:text-4xl">
              Popular flight routes
            </h2>
          </div>
          <p className="max-w-xl text-sm font-medium leading-6 text-slate-500 sm:text-base">
            Based on recent searches, route demand, and flexible round-trip
            pricing.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {recommendations.map((item) => (
            <div
              key={item.id}
              className="group flex min-h-[360px] cursor-pointer flex-col overflow-hidden rounded-[1.5rem] border border-slate-200 bg-white shadow-[0_12px_35px_rgba(15,23,42,0.06)] transition-all duration-300 hover:-translate-y-1 hover:border-blue-100 hover:shadow-[0_22px_55px_rgba(40,113,211,0.16)]"
            >
              <div className="relative h-44 w-full overflow-hidden bg-slate-100">
                <img
                  src={item.imageUrl}
                  alt={item.city}
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
                  loading="lazy"
                />
                <span className="absolute left-4 top-4 rounded-full bg-white/95 px-3 py-1 text-xs font-black uppercase tracking-wide text-[#2871d3] shadow-sm">
                  {item.tripType}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-5">
                <div className="mb-6 flex items-start justify-between gap-4">
                  <div className="min-w-0">
                    <h3 className="truncate text-xl font-black leading-tight text-slate-950">
                      {item.city}
                    </h3>
                    <p className="mt-1 text-sm font-bold text-slate-500">
                      {item.route}
                    </p>
                  </div>
                  <span className="shrink-0 text-xl font-black leading-tight text-slate-950">
                    {item.price}
                  </span>
                </div>

                <div className="mt-auto rounded-2xl bg-[#f8f9fc] p-4">
                  <div className="mb-3 flex items-center justify-between gap-3">
                    <span className="text-xs font-semibold leading-5 text-slate-500">
                      Similar flights usually cost between {item.typicalLow} -{" "}
                      {item.typicalHigh}.
                    </span>
                    <PriceIndicator level={item.priceLevel} />
                  </div>
                  <button className="w-full rounded-full bg-[#2871d3] px-4 py-3 text-sm font-black text-white shadow-lg shadow-blue-600/20 transition hover:bg-[#155bc2]">
                    View deal
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RecommendedTrips;
